  
<!--降雨分布-->
<template>
    <div class="rainfb">
            <img style="width:100%;height:100%" src="http://58.20.42.86/pic/rcsftp/isoresult.jpg" />
    </div>
</template>
<script>
import $ from "jquery";
let moment = require("moment");
export default {
  name: "rainfb",
  data() {
    return {
      height:0,
      width:0,
    };
  },
 
  methods: {
  },
  mounted() {
    // $(".rainfb").height(window.innerHeight-140-35-20);
    var w=$(".rainfb").width();
    this.height=$(".rainfb").height()-2;
    this.width=w;
  }
};
</script>
<style scoped lang='less'>
 .rainfb{
 
   width:100%;
    padding-top: 128px;
 }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/rainFb.vue